import {
  ACCESS_LEVELS,
  OFFLINE_MODULES,
  MODULES,
  HOME_MODULE,
  ADMINISTRATION_MODULES
} from "@hub/authentication/src/constants"
import Store from "@hub/core/src/store"

const getOnlineModules = isMobile => {
  const modules = [...MODULES]
  if (!isMobile) modules.push(...ADMINISTRATION_MODULES)
  return modules
}

const getModules = isMobile => {
  const { onlineStatus } = Store.state.Core
  if (onlineStatus) return getOnlineModules(isMobile)
  return [...OFFLINE_MODULES]
}

export default {
  permissions: state => state.user?.role?.permissions || {},

  menuPermissions: state => state.user?.role?.menus?.sidebar || {},

  getMenuPermissions: state => state.user?.role?.menus?.sidebar || {},

  home_permissions: state => state.user?.role?.menus?.home || {},

  currentProvider: state => state.provider?.slug?.toLowerCase(),

  isAdmin: state => state.user.is_admin,

  isSeller: state => state.user?.role?.level === ACCESS_LEVELS.seller,

  getIsUsingPwa: state => state.isUsingPwa,

  isBackoffice: state => state.user?.role?.level === ACCESS_LEVELS.backoffice,

  getAccessTimeNotAllowed: state => state.accessTimeNotAllowed,

  getCurrentProviderCode: state => state.provider?.code?.toUpperCase() || "",

  getTenantSearchable: state => state.tenant?.searchable?.toLowerCase() || "",

  getTenantIntegration: state => state.tenant?.integrator?.toLowerCase() || "",

  hasDashboard: state => Boolean(state.dashboard?.available),

  getCurrentProviderId: state => state.provider?.id,

  getCurrentProviderUuid: state => state.provider?.uuid,

  getFirstAccess: state => state.first_access,

  getSecurity: state => state.user.security,

  getEnpsLastAnswered: state => state.user.enps.last_answered,

  getEnpsReply: state => state.user.enps.reply,

  getToken: state => state.token,

  getUserUuid: state => state.user.uuid,

  getUserName: state => state.user.name,

  getUserEmail: state => state.user.email,

  getUserPosUuid: state => (state.user.pos.length ? state.user.pos[0] : null),

  getShowModalLogin: state => state.sessionTime.showModalLogin,

  getIsMobile: state => state.isMobile,

  getTermsOfUseSigned: state => state.termOfUseSigned,
  getMfaValidated: state => state.mfaValidated,

  getConfirmationType: state => state.confirmationType,

  getGeolocationRequired: state => state.geolocationRequired,

  getShowModalUserContactsConfirmation: state => state.showModalUserContactsConfirmation,

  getUserEmailValidated: state => state.userEmailValidated,

  getUserPhoneValidated: state => state.userPhoneValidated,

  getCanSkipContactValidation: state => state.canSkipContactValidation,

  getDaysToContactValidationDeadline: state => state.daysToContactValidationDeadline,

  hasModule:
    (state, getters) =>
    (module, specificPermission = "") =>
      getters.permissions[module] &&
      (specificPermission
        ? getters.permissions[module].includes(specificPermission)
        : true),

  _checkPermissionsByModule:
    (state, { hasModule, permissions }) =>
    (module, permission) => {
      if (module instanceof Array) {
        let hasPermission = false

        module.forEach(value => {
          if (() => _checkPermissionsByModule(value, permission) === true) {
            hasPermission = true
          }
        })

        return hasPermission
      }
      if (!hasModule(module)) {
        return false
      }
      if (permission instanceof Array) {
        return Boolean(
          permissions[module].find(permissionModule => {
            return permission.includes(permissionModule)
          })
        )
      }
      return hasModule(module, permission)
    },

  getMenus: (state, { menuPermissions }) => {
    const sidebarMenus = [HOME_MODULE]

    let modules = getModules(state.isMobile)

    modules.forEach(module => {
      const menuPermission = menuPermissions[module.title]
      if (menuPermission) {
        let subMenus = []
        module.subMenus.forEach(subMenu => {
          const itemPermission = menuPermission.menus.find(
            sub => sub.label === subMenu.title
          )
          if (!itemPermission) return

          subMenus.push({
            ...subMenu,
            ...itemPermission
          })
        })

        sidebarMenus.push({
          ...module,
          ...menuPermission,
          subMenus
        })
      } else if (module.isTitleSection) {
        sidebarMenus.push(module)
      }
    })

    return sidebarMenus
  }
}
